export default 'https://tme.understood.org/assets/brain-freeze.6a28cf2b.lottie'